import FbButton, { IFbButtonProps } from 'components/FbUI/FbButton'
import { cn } from 'components/UI/cn'
import React from 'react'
import { IconType } from 'react-icons'

export interface ITableButtonProps extends IFbButtonProps {
  icon?: React.ElementType | IconType
  text?: string
  activeValue?: string | null
  iconSize?: number

  postpendIcon?: React.ElementType | IconType
  onPostpendIconClick?: () => void
  /** Opt out of the default xl:min-w-[140px] / xl:min-w-[120px] so the
   *  button sizes to its content. Use for one-off contexts (e.g. the
   *  Event History filter) where a row of mixed-width buttons reads
   *  better than uniformly-sized ones. */
  hugContent?: boolean
}

const TableButton = React.forwardRef((props: ITableButtonProps, ref: any) => {
  const {
    icon,
    text,
    activeValue,
    iconSize = 24,
    postpendIcon,
    onPostpendIconClick,
    hugContent = false,
    ...rest
  } = props

  const renderIcon = (
    IconComponent: React.ElementType | IconType | undefined,
    size: number
  ) => {
    if (!IconComponent) return null
    return <IconComponent size={size} />
  }

  return (
    <div className={cn('flex min-h-[38px]', !hugContent && 'xl:min-w-[140px]')}>
      <FbButton
        ref={ref}
        variant="secondary"
        className={cn(
          {
            active: activeValue !== null,
            'rounded-r-none': !!postpendIcon,
          },
          'bg-white gap-2 justify-start text-nowrap flex-1',
          !hugContent && 'xl:min-w-[120px]'
        )}
        {...rest}
      >
        {renderIcon(icon, iconSize)}
        <span className={'hidden xl:inline'}>
          {text}
          {activeValue && (
            <span>
              {' '}
              (
              <span>
                <strong>{activeValue}</strong>
              </span>
              )
            </span>
          )}
        </span>
      </FbButton>
      {!!postpendIcon && (
        <FbButton
          variant={'primary'}
          className="rounded-l-none rounded-r px-2 -ml-1"
          onClick={onPostpendIconClick}
        >
          {renderIcon(postpendIcon, iconSize)}
        </FbButton>
      )}
    </div>
  )
})
TableButton.displayName = 'TableButton'
export default TableButton
